export default "__VITE_ASSET__4cb69bfc__"